import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { isActiveAccountOfType } from '../../reducers/accountsReducer';
import { getActiveAccount } from '../../reducers/activeAccountSelectors';
import useIsFCM from '../../hooks/useIsFCM';
import useIsCBD from '../../hooks/useIsCBD';

const EntityAgreementTextBlock = styled.p`
  margin: 0;
`;

const EntityAgreementText = () => (
  <div>
    <EntityAgreementTextBlock>
      Your signed agreement is available upon request to{' '}
      <a href="mailto:digital.membership@cboe.com">
        digital.membership@cboe.com
      </a>
      .
    </EntityAgreementTextBlock>
    <EntityAgreementTextBlock>
      Please note that any updates to the Cboe Digital Member Master Agreement
      will be noticed to you via email.
    </EntityAgreementTextBlock>
    <EntityAgreementTextBlock>
      Current versions of the Cboe Digital Member Master Agreement (Entity) can
      be found{' '}
      <a href="https://www.cboedigital.com/regulation/membership/">here</a>.
    </EntityAgreementTextBlock>
  </div>
);

const DownloadApplicationPacket = () => {
  const activeAccount = useSelector(getActiveAccount);
  const isActiveAccountOfTypeIraLSG = useSelector((state) =>
    isActiveAccountOfType(state, ['IRAL', 'IRAS', 'IRAG']),
  );
  const isFCM = useIsFCM();
  const isCBD = useIsCBD();

  if (isFCM || isCBD) {
    return null;
  }

  return activeAccount?.firmCode === 'DM' && !isActiveAccountOfTypeIraLSG ? (
    // Stub for Application Packet button
    // Note: We cannot simply remove the DownloadApplicationPacket component as 
    //  the EntityAgreementText below needs to remain
    <div></div>
  ) : (
    <EntityAgreementText />
  );
};

DownloadApplicationPacket.defaultProps = {
  user: {
    userId: '',
  },
};

DownloadApplicationPacket.propTypes = {
  user: PropTypes.shape({
    userId: PropTypes.string,
  }),
};

export default DownloadApplicationPacket;
